import React from "react";
import * as styles from "./WordButton.module.css";
import { Toggle } from "../ui/toggle";
import { GameStatusContext } from "../../providers/GameStatusProvider";
import { AnimatedWord } from "../AnimatedWord/AnimatedWord";

function WordButton({ 
  word, 
  fullCandidateSize, 
  isAnimating = false, 
  animationDelay = 0,
  proposalWord = null 
}) {
  const { guessCandidate, setGuessCandidate, isProposalPhase } = React.useContext(GameStatusContext);
  const [isSelected, setIsSelected] = React.useState(!!guessCandidate.includes(word));
  const isCandidateListFull = guessCandidate.length == fullCandidateSize;

  React.useEffect(() => {
    setIsSelected(!!guessCandidate.includes(word));
  }, [guessCandidate, word]);

  function flipSelection() {
    if (isSelected) {
      const updatedGuessCandidate = guessCandidate.filter((w) => w !== word);
      setGuessCandidate(updatedGuessCandidate);
      setIsSelected(false);
    } else if (!isCandidateListFull) {
      setGuessCandidate([...guessCandidate, word]);
      setIsSelected(true);
    }
  }

  function getFontSize(word) {
    const baseLength = 6;
    const wordLength = word.length;
    let fontSize = 3.2;
    if (wordLength > baseLength) {
      const numExtraChars = wordLength - baseLength;
      fontSize = fontSize - numExtraChars * 0.05;
      fontSize = Math.max(1, fontSize);
      return `${fontSize}vw`;
    }
    return null;
  }

  // Determine the content to display
  const content = (
    <p 
      style={{ fontSize: getFontSize(word), lineHeight: "1.05", wordWrap: "normal" }}
      className="uppercase md:text-xs font-semibold"
    >
      {word}
    </p>
  );

  // If we're in the middle of animating to a proposal word
  if (isAnimating && proposalWord) {
    return (
      <div 
        className={`${styles.growShrink} select-none inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors w-full h-full min-h-[60px] ${
          isSelected 
            ? 'bg-primary text-primary-foreground hover:bg-primary/90' 
            : 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
        }`}
        onClick={flipSelection}
        style={{ cursor: 'pointer' }}
      >
        <AnimatedWord 
          word={{ original: word, replacement: proposalWord }}
          delay={animationDelay}
          initialDelay={1000} // 1 second initial delay
        />
      </div>
    );
  }

  // For non-animating or non-proposal words, use the Toggle component
  return (
    <div className="h-full">
      <Toggle
        className={`${styles.growShrink} select-none w-full h-full`}
        variant="connections"
        pressed={isSelected}
        onClick={flipSelection}
      >
        <div className="w-full">
          {content}
        </div>
      </Toggle>
    </div>
  );
}

export default WordButton;
